import { render, staticRenderFns } from "./inviteTenant.vue?vue&type=template&id=43506905&scoped=true&"
import script from "./inviteTenant.vue?vue&type=script&lang=js&"
export * from "./inviteTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43506905",
  null
  
)

export default component.exports